import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const Theme = 'theme'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { expires: 1 })
}

export function removeToken () {
  // this.$router.push('/login')
  return Cookies.remove(TokenKey)
}

export function getColors () {
  return Cookies.get(Theme)
}

export function setColors (colors) {
  // console.log(JSON.stringify(colors));

  return Cookies.set(Theme, JSON.stringify(colors))
}

export function removeColors () {
  return Cookies.remove(Theme)
}
